/** Reminders of an event as the packlists API sends them (P4); a field the role does not see is missing. */
export type Reminder = {
  id: string;
  eventId: string;
  source: 'rule' | 'manual';
  ruleId: string | null;
  ruleName: string | null;
  text?: string;
  dueDay?: string | null;
  done?: boolean;
  doneAt?: string | null;
  doneByName?: string | null;
  /** "zrobione automatycznie" when the program ticked it off (the packlist got its first line). */
  doneNote?: string | null;
  authorName: string | null;
  version: number;
};

export const REMINDERS_RESOURCE = 'packlists.reminders';
export const remindersKey = (eventId: string) => ['packlists', 'reminders', eventId] as const;

/** 'YYYY-MM-DD' → '2.11.2026'. */
export function dayLabel(day: string): string {
  const [y, m, d] = day.split('-');
  return `${Number(d)}.${m}.${y}`;
}

const WHEN = new Intl.DateTimeFormat('pl-PL', { timeZone: 'Europe/Warsaw', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

/** The small line under a reminder: where it comes from, then who ticked it off or its day. `today`: Warsaw day. */
export function reminderMeta(r: Reminder, today: string): string {
  const parts = [r.source === 'rule' ? `z reguły „${r.ruleName ?? '…'}”` : r.authorName ? `dodał(a) ${r.authorName}` : 'dodane ręcznie'];
  if (r.done) parts.push(`${r.doneNote ? r.doneNote : `zrobione: ${r.doneByName ?? 'ktoś'}`}${r.doneAt ? `, ${WHEN.format(new Date(r.doneAt))}` : ''}`);
  else if (r.dueDay) parts.push(`${r.dueDay < today ? 'termin minął' : 'termin'} ${dayLabel(r.dueDay)}`);
  return parts.join(' · ');
}

/** Today in Warsaw as 'YYYY-MM-DD'. */
export const warsawToday = (now = new Date()): string => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw' }).format(now);
